import { memo } from "react";
import Typography from "@mui/material/Typography";
import CheckIcon from '@mui/icons-material/Check';
import Account from "ui/molecules/Account";
import type { PaymentMethod } from "features/paymentMethods/types";
import { Box, Tooltip } from "@mui/material";

type Props = PaymentMethod & {
    readonly selected?: boolean;
    readonly onSelectionChange?: (checked: boolean) => void;
};

const PaymentMethodName = ({ name, selected = false, onSelectionChange }: Props) => {
    const isSelectable = Boolean(onSelectionChange);

    return (
        <Account
            CustomAvatarProps={{
                name: selected ? '' : String(name),
                alt: selected ? `${name} selected` : `Select ${name}`,
                color: selected ? 'success' : 'default',
                children: selected ? <CheckIcon fontSize='small' /> : undefined,
                ...(isSelectable && {
                    role: 'checkbox',
                    'aria-checked': selected,
                    tabIndex: 0,
                    // Keep the accordion closed when (de)selecting
                    onClick: event => {
                        event.stopPropagation();
                        onSelectionChange?.(!selected);
                    },
                    onKeyDown: event => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            event.stopPropagation();
                            onSelectionChange?.(!selected);
                        }
                    },
                    sx: {
                        cursor: 'pointer',
                        outline: selected ? '2px solid' : 'none',
                        outlineColor: 'success.light'
                    }
                })
            }}
        >

            <Typography
                sx={{
                    textDecoration: 'capitalize'
                }}
            >
                <Tooltip title={name}>
                    <Box
                        sx={{
                            width: '185px',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        {name}
                    </Box>
                </Tooltip>
            </Typography>
        </Account>
    );
};

export default memo(PaymentMethodName);
